import {dataFetcher} from "../../services/dataGuetter/dataFetcher";


export async function getAllRoleNiveau():Promise<RoleNiveau[]>{
    const res:any = await dataFetcher(`role_niveaus`, {method:'get'})
    return res["hydra:member"];
}